import { Routes } from "@src/context/router/RouterContext";
import { getInitialRoute } from "@src/context/router/RouterContext.utils";
import { useAttributeConfig } from "@src/hooks/useAttributeConfig";
import { useGlobalState } from "@src/hooks/useGlobalState";
import { useRouter } from "@src/hooks/useRouter";

export const useRestart = (): { restart: () => void; showRestartButton: boolean } => {
    const { setBrandId, setModelId, setContextArticleId, setSearchTerm, setBreadcrumbs } = useGlobalState();
    const router = useRouter();
    const config = useAttributeConfig();

    const initialRoute = getInitialRoute(config);
    const scoped =
        config.entryPoint && config.entryPoint.scoped !== undefined ? config.entryPoint.scoped && config.entryPoint.view != "landing" : false;

    const showRestartButtonOnScopedCompatibilityCheck =
        scoped &&
        config.entryPoint?.view === "compatibilityCheck" &&
        (router.currentRoute === Routes.ComponentGroupOverview || router.currentRoute === Routes.SubGroupDetail);

    const showRestartButton = !scoped || showRestartButtonOnScopedCompatibilityCheck;

    return {
        restart: () => {
            setBreadcrumbs([]);
            setBrandId(undefined);
            setModelId(undefined);
            setContextArticleId(undefined);
            setSearchTerm("");
            router.setRoute(scoped ? initialRoute : Routes.Landing);
        },
        showRestartButton: showRestartButton,
    };
};
